function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomToiletBathroomFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.162 21.906l.924-.065a6.374 6.374 0 005.834-5.308H6.08a6.369 6.369 0 002.289 3.908l.369.3V27h10.39l.034-5.095zM9 14.533H6V5h3v9.533zM4 3h7v11.533h17v1c0 4.037-2.942 7.47-6.85 8.186L21.113 29H6.738v-7.326C4.992 20.082 4 17.87 4 15.534V3zm24 9.533H13v-2h15v2z",
    fill: props.color
  }));
}

export default SvgIconRoomToiletBathroomFilled;